export default {
  nav: {
    portfolio: 'Портфоліо',
    services: 'Послуги',
    howWeWork: 'Як ми працюємо',
    about: 'Про нас',
    team: 'Команда',
    contact: 'Контакти',
    startProject: 'Розпочати проєкт',
  },
  hero: {
    badge: 'Українська IT-компанія',
    title1: 'Будуй свій',
    title2: 'бізнес',
    withUs: 'разом із нами',
    subtitle: 'Ми автоматизуємо, створюємо та масштабуємо ваші цифрові продукти — від ботів до повноцінних платформ',
    startProject: 'Розпочати проєкт',
    viewPortfolio: 'Переглянути портфоліо',
    projects: 'Проєктів',
    years: 'Років',
    satisfaction: 'Задоволеність',
  },
  portfolio: {
    title1: 'Що ми',
    title2: 'створили',
    subtitle: 'Ознайомтесь із нашими останніми проєктами — від фреймворків з відкритим кодом до фінтех-платформ',
    project_aiober_desc: 'Python фреймворк для масштабованих Viber ботів із асинхронною підтримкою та простою інтеграцією API.',
    project_karum_desc: "Фінансовий трекер, що об'єднує криптогаманці та банківські рахунки в єдиній панелі.",
    project_bookflow_desc: 'Система бронювання послуг із записом на прийом, плануванням та автоматичними нагадуваннями.',
    project_allix_desc: 'Готується щось велике. Слідкуйте за нашим наступним проривним проєктом.',
    link_github: 'GitHub',
    link_telegram: 'Telegram',
  },
  services: {
    title1: 'Наші',
    title2: 'послуги',
    subtitle: 'Ми пропонуємо комплексні рішення для цифрової трансформації вашого бізнесу',
    getStarted: 'Розпочати',
    bots_title: 'Розробка ботів',
    bots_desc: 'Боти для Telegram, Viber, Discord із кастомною логікою та інтеграціями.',
    automation_title: 'Автоматизація бізнесу',
    automation_desc: 'Економте час та зменшуйте ручну працю за допомогою інтелектуальних автоматизованих процесів.',
    webdev_title: 'Веб-розробка',
    webdev_desc: 'Вебсайти, платформи, інтернет-магазини на сучасних технологічних стеках.',
    hosting_title: 'Хостинг та підтримка',
    hosting_desc: 'Ми розміщуємо та підтримуємо ваші проєкти, щоб ви могли зосередитися на зростанні.',
  },
  howWeWork: {
    title1: 'Як ми',
    title2: 'працюємо',
    subtitle: 'Від ідеї до запуску та далі — перевірений процес',
    step1_title: 'Планування та вимоги',
    step1_desc: 'Ми починаємо із розуміння ваших бізнес-потреб, цілей та технічних обмежень.',
    step2_title: 'Архітектура та системний дизайн',
    step2_desc: 'Ми проєктуємо масштабовану, підтримувану архітектуру під ваші потреби.',
    step3_title: 'UI/UX дизайн',
    step3_desc: 'Ми створюємо інтуїтивно зрозумілі, візуально привабливі інтерфейси.',
    step4_title: 'Розробка',
    step4_desc: 'Ми створюємо ваш продукт із чистим, ефективним кодом на сучасних технологіях.',
    step5_title: 'Тестування та QA',
    step5_desc: 'Ретельне тестування гарантує бездоганну роботу продукту в усіх сценаріях.',
    step6_title: 'Розгортання',
    step6_desc: 'Ми розгортаємо в продакшн із моніторингом, CI/CD та стратегіями без простою.',
    step7_title: 'Підтримка та масштабування',
    step7_desc: 'Постійна підтримка, моніторинг продуктивності та масштабування разом із вашим бізнесом.',
  },
  about: {
    badge: 'Про нас',
    title1: 'Український IT',
    title2: 'із місією',
    p1: 'Quaron Software — українська IT-компанія, яка спеціалізується на автоматизації, ботах та масштабованих програмних рішеннях. Ми допомагаємо бізнесу оптимізувати процеси, знижувати витрати та створювати сучасні цифрові продукти.',
    p2: 'Наша команда поєднує глибокі технічні знання та пристрасть до створення інструментів, що справді змінюють ситуацію. Від кастомних ботів для Telegram та Viber до повномасштабних фінтех-платформ — ми ставимося до кожного проєкту як до можливості для інновацій.',
    p3: 'Ми віримо у відкритий код, прозорість та довгострокові партнерства з нашими клієнтами. Чи ви стартап, що шукає автоматизацію, чи великий бізнес, готовий до модернізації — ми готові допомогти.',
    projectsDelivered: 'Реалізованих проєктів',
    yearsInBusiness: 'Років у бізнесі',
    teamMembers: 'Учасників команди',
    quote: 'Ми не просто пишемо код. Ми вирішуємо реальні бізнес-проблеми за допомогою надійного, масштабованого та елегантного програмного забезпечення.',
    companyName: 'Quaron Software',
    companySubtitle: 'Українська IT-компанія',
    missionTitle: 'Наша місія',
    mission1: 'Надати високоякісне програмне забезпечення вчасно',
    mission2: 'Розширити можливості бізнесу через автоматизацію',
    mission3: 'Будувати довгострокові партнерства з клієнтами',
    mission4: 'Робити внесок у спільноту відкритого коду',
  },
  team: {
    title1: 'Наша',
    title2: 'команда',
    subtitle: 'Люди, що стоять за Quaron Software',
    nazar: 'Назар',
    roman: 'Роман',
    nickname: 'Псевдонім',
    role_nazar: 'Засновник та головний інженер',
    role_roman: 'Співзасновник та дизайнер',
  },
  moneyButton: {
    zone: 'Ігрова зона',
    balance: 'Баланс',
    perClick: 'За клік',
    perSecond: 'За секунду',
    clicks: 'Кліків',
    money: 'Бабло',
    btc: 'BTC',
    upgrade_cursor: 'Кращий курсор',
    upgrade_bot: 'Авто-бот',
    upgrade_server: 'Ферма серверів',
    upgrade_ai: 'AI агент',
    perClickLabel: '/клік',
    perSecondLabel: '/сек',
    owned: 'x',
  },
  contact: {
    title1: 'Давайте',
    title2: 'створимо',
    title3: 'щось',
    subtitle: 'Маєте ідею проєкту? Напишіть нам і ми відповімо протягом 24 годин.',
    nameLabel: "Ваше ім'я",
    emailLabel: 'Email',
    messageLabel: 'Повідомлення',
    namePlaceholder: 'Іван Петренко',
    emailPlaceholder: 'ivan@example.com',
    messagePlaceholder: 'Розкажіть про ваш проєкт...',
    sendMessage: 'Надіслати повідомлення',
    messageSent: 'Повідомлення надіслано!',
    email: 'quaronsoftware@proton.me',
    telegram: '@notGucul',
  },
  footer: {
    description: 'Українська IT-компанія, що спеціалізується на автоматизації, ботах та масштабованих програмних рішеннях.',
    navigation: 'Навігація',
    moneyButton: 'Ігрова зона',
    services: 'Послуги',
    botDev: 'Розробка ботів',
    bizAuto: 'Автоматизація бізнесу',
    webDev: 'Веб-розробка',
    hosting: 'Хостинг та підтримка',
    copyright: 'Quaron Software. Всі права захищені.',
    privacy: 'Політика конфіденційності',
    terms: 'Умови використання',
  },
  notFound: {
    title: 'Сторінку не знайдено',
    subtitle: 'Сторінка, яку ви шукаєте, не існує або була переміщена.',
    backHome: 'На головну',
  },
};